window.thumbnailsResizingFormatter = function(value, row) {
    switch (value) {
        case 'cover':
            return '<i class="fal fa-maximize text-muted"></i>';
        case 'pad':
            return '<i class="fal fa-fill text-muted"></i>';
        case 'resize':
            return '<i class="fal fa-minimize text-muted"></i>';
    }
};
